import { Component } from '@angular/core';
import { Title,Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: ['./seo.component.css']
})
export class SeoComponent {

  constructor(private titleServvice:Title,private metaService: Meta){}
    ngOnInit(): void {
      this.titleServvice.setTitle('Leading SEO Company in Hyderabad | Maximize Your Online Visibility')
      this.metaService.addTags([
        { name: 'description', content: 'Partner with the leading SEO company in Hyderabad to maximize your online presence. Our expert team delivers proven strategies to grow your business effectively.' },
        { name: 'keywords', content: 'Best SEO Company in Hyderabad ' }
      ]);
    }
}
